import React from 'react';
import { Card, Accordion } from 'react-bootstrap';

export default function Step5ARodGrommet({
  step3,
  step31,
  depSet,
  accordionActiveKey,
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  pageLanguage,
  step3ARod,
  setStep3ARod,
  clearInputs,
  setCart,
  setDeps,
  inputs,
  step3ARodErr1,
  NextStep,
  nameStep
}) {
  return (
   <Card className={step3 === "true" && step31 === "true" ? "" : "noDisplay"}>
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
       !accordionActiveKey.startsWith("3")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="3A"
       stepNum={t(nameStep)}
       stepTitle={t("dk_step2A")}
       stepRef="315"
       type="1"
       required={requiredStep["315"]}
       stepSelected={
         stepSelectedLabel["315"] === undefined ? "" : stepSelectedLabel["315"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="3A">
     <Card.Body>
       <div className="card_body card_body_radio card_body_finished_length card_body_finished_length_grommet">
         <div className="box100">
           <p className="step_selection_title">{t("dk_step2A_title")}</p>
         </div>
         <div className="box25 radio_style">
           <img
             src={require("../../Images/drapery/european/finished-rod-sill.svg").default}
             className="img-fluid height_auto"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Sill")}
             value="1"
             name="step3ARod"
             ref-num="315"
             id="3ARod1"
             checked={step3ARod === "Sill"}
             onChange={(e) => {
               setStep3ARod("Sill");
               clearInputs(e);
               setCart(
                 "FinishedLengthType",
                 "Sill",
                 "RodToFloor,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
               );
               setDeps(
                 "325,335,345",
                 "315,3ARod1,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,336"
               );
             }}
             ref={(ref) => (inputs.current["3ARod1"] = ref)}
           />
           <label htmlFor="3ARod1">{t("Sill")}</label>
         </div>
         <div className="box25 radio_style">
           <img
             src={require("../../Images/drapery/european/finished-rod-apron.svg").default}
             className="img-fluid height_auto"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Apron")}
             value="2"
             name="step3ARod"
             ref-num="315"
             id="3ARod2"
             checked={step3ARod === "Apron"}
             onChange={(e) => {
               setStep3ARod("Apron");
               clearInputs(e);
               setCart(
                 "FinishedLengthType",
                 "Apron",
                 "RodToFloor,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
               );
               setDeps(
                 "325,335,345",
                 "315,3ARod1,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,336"
               );
             }}
             ref={(ref) => (inputs.current["3ARod2"] = ref)}
           />
           <label htmlFor="3ARod2">{t("Apron")}</label>
         </div>
         <div className="box25 radio_style">
           <img
             src={ require("../../Images/drapery/european/finished-rod-puddle.svg").default}
             className="img-fluid height_auto"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Floor")}
             value="3"
             name="step3ARod"
             ref-num="315"
             id="3ARod3"
             checked={step3ARod === "Floor"}
             onChange={(e) => {
               setStep3ARod("Floor");
               clearInputs(e);
               setCart(
                 "FinishedLengthType",
                 "Floor",
                 "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
               );
               setDeps(
                 "325,336,345",
                 "315,3ARod1,335,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
               );
             }}
             ref={(ref) => (inputs.current["3ARod3"] = ref)}
           />
           <label htmlFor="3ARod3">{t("Floor")}</label>
         </div>
         <div className="box25 radio_style">
           <img
             src={require("../../Images/drapery/european/finished-rod-floor.svg").default}
             className="img-fluid height_auto"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Slight Puddle")}
             value="4"
             name="step3ARod"
             ref-num="315"
             id="3ARod4"
             checked={step3ARod === "Slight Puddle"}
             onChange={(e) => {
               setStep3ARod("Slight Puddle");
               clearInputs(e);
               setCart(
                 "FinishedLengthType",
                 "Slight Puddle",
                 "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
               );
               setDeps(
                 "325,336,345",
                 "315,3ARod1,335,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
               );
             }}
             ref={(ref) => (inputs.current["3ARod4"] = ref)}
           />
           <label htmlFor="3ARod4">{t("Slight Puddle")}</label>
         </div>

         <div
           className={
             step3ARod === "Apron"
               ? step3ARodErr1
                 ? "secondary_options secondary_options_err secondary_options_text"
                 : "secondary_options secondary_options_text"
               : "noDisplay"
           }
         >
           <div className="card-body-display-flex">
             <div className="checkbox_style checkbox_style_step2">
               <span className="checkbox_text box100">
                 {t("grommet_apron_checkbox_title")}
               </span>
             </div>
           </div>
         </div>

         <div
           className={
             step3ARod === "Slight Puddle"
               ? "secondary_options secondary_options_text"
               : "noDisplay"
           }
         >
           <div className="card-body-display-flex">
             <div className="checkbox_style checkbox_style_step2">
               <span className="checkbox_text box100">{t("puddle_text")}</span>
             </div>
           </div>
         </div>
         {step3ARodErr1 && (
           <div className="input_not_valid">{t("grommet_step3AErr1")}</div>
         )}
         <NextStep currentStep="315" eventKey="3B">
           {t("NEXT STEP")}
         </NextStep>
       </div>

       <div className="accordion_help">
         <div className="help_container">
           <div className="help_column help_left_column">
             <p className="help_column_header"></p>
             <ul className="help_column_list">
               <li className="no_listStyle">
                 <b>{t("dk_step2a_help1")}</b>
                 {t("dk_step2a_help2")}
               </li>
               <li className="no_listStyle">
                 <b>{t("grommet_step3a_help2")}</b>
                 {t("grommet_step3a_help3")}
               </li>
               <li className="no_listStyle">
                 <b>{t("grommet_step3a_help4")}</b>
                 {t("grommet_step3a_help5")}
               </li>
               <li className="no_listStyle">
                 <b>{t("grommet_step3a_help6")}</b>
                 {t("grommet_step3a_help7")}
               </li>
             </ul>
           </div>
         </div>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
